import { getCoreRowModel } from "@tanstack/react-table"
import { type FC } from "react"

import { useCheckedInPurchaseOrderColumns } from "../../hooks/useCheckedInPurchaseOrderColumns"
import type { PurchaseOrderLineWithReceiptContext } from "../../types"
import { getGoodsReceiptPurchaseOrderLines } from "../../utils"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { GoodsReceipt } from "@/graphql/codegen/graphql"

interface CheckedInPurchaseOrdersTableProps {
  goodsReceipt: GoodsReceipt
}

export const CheckedInPurchaseOrdersTable: FC<CheckedInPurchaseOrdersTableProps> = ({ goodsReceipt }) => {
  const purchaseOrderLines = getGoodsReceiptPurchaseOrderLines(goodsReceipt)

  const columns = useCheckedInPurchaseOrderColumns()

  return (
    <AerosBaseTable<PurchaseOrderLineWithReceiptContext>
      slotProps={{
        headerCell: { className: "bg-primary-100" },
      }}
      features={{
        tanstackOptions: {
          data: purchaseOrderLines,
          columns,
          enableSorting: false,
          getCoreRowModel: getCoreRowModel(),
        },
      }}
      noDataMessage='No purchase order lines found'
    />
  )
}
